/* D'ORVÉN — Pro layer: race ticker, gallery HUD + counter, launch label, count-ups, scroll reveals */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  ready(function () {
    var pdp = document.querySelector('[data-dv-pdp]');

    /* ---- Race ticker: real store facts only ---- */
    if (pdp && !document.querySelector('.dvp-ticker')) {
      var facts = ['Buy 1, Get 1 Free', 'Complimentary tracked shipping', '2-year international warranty', '30-day returns', 'Automatic skeleton movement', 'Secure checkout'];
      var row = facts.map(function (f) { return '<span class="dvp-ticker__item"><i class="dvp-ticker__flag" aria-hidden="true"></i>' + f + '</span>'; }).join('');
      var t = document.createElement('div');
      t.className = 'dvp-ticker'; t.setAttribute('aria-label', facts.join(' · '));
      t.innerHTML = '<div class="dvp-ticker__track" aria-hidden="true">' + row + row + '</div>';
      var host = pdp.closest('.shopify-section') || pdp;
      host.parentNode.insertBefore(t, host.nextSibling);
    }

    /* ---- Gallery HUD + counter ---- */
    if (pdp) {
      var stage = pdp.querySelector('.dv-pdp__stage');
      var track = pdp.querySelector('[data-dv-track]');
      if (stage && !stage.querySelector('.dvp-hud')) {
        var hud = document.createElement('div'); hud.className = 'dvp-hud'; hud.setAttribute('aria-hidden', 'true');
        hud.innerHTML = '<i></i><i></i><i></i><i></i>';
        stage.appendChild(hud);
        var slides = track ? track.querySelectorAll('.dv-pdp__slide') : [];
        if (slides.length > 1) {
          var c = document.createElement('div'); c.className = 'dvp-count'; c.setAttribute('aria-hidden', 'true');
          var pad = function (n) { return (n < 10 ? '0' : '') + n; };
          var upd = function () { var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1)); c.innerHTML = '<b>' + pad(i + 1) + '</b> / ' + pad(slides.length); };
          stage.appendChild(c); upd();
          track.addEventListener('scroll', function () { window.requestAnimationFrame(upd); }, { passive: true });
        }
      }

      /* ---- Launch label above price (factual: shows the saving percentage) ---- */
      var price = pdp.querySelector('[data-dv-price]');
      var badge = pdp.querySelector('[data-dv-badge]');
      if (price && badge && !pdp.querySelector('.dvp-launch')) {
        var l = document.createElement('div'); l.className = 'dvp-launch';
        l.textContent = 'Offer price · ' + badge.textContent.replace(/[^0-9%]/g, '') + ' off';
        price.parentNode.insertBefore(l, price);
      }
    }

    /* ---- Count-up on spec numbers ---- */
    var nums = [];
    document.querySelectorAll('.pk-spec__cell b').forEach(function (b) {
      var node = b.firstChild;
      if (node && node.nodeType === 3 && /^\d+$/.test(node.textContent.trim())) nums.push({ node: node, to: parseInt(node.textContent.trim(), 10), w: node.textContent.trim().length });
    });

    /* ---- Scroll reveals ---- */
    var sel = ['.pk-story__head', '.pk-story__text', '.pk-spec__head', '.pk-spec__cell', '.pk-spec__foot', '.dv-why__pillar', '.dv-why__offer', '.dv-why__compare', '.dv-faq__item', '.dv-card', '.dv-pdp__acc', '.dv-assurance__item'];
    var els = [];
    sel.forEach(function (s) { document.querySelectorAll(s).forEach(function (el, i) { el.classList.add('dvp-r'); el.style.transitionDelay = Math.min(i % 4, 3) * 70 + 'ms'; els.push(el); }); });
    var wipes = [];
    document.querySelectorAll('.pk-livery, .dvp-ticker').forEach(function (el) { el.classList.add('dvp-wipe'); el.style.clipPath = 'inset(0 97% 0 0)'; wipes.push(el); });

    /* Mobile: keep the buy box short - description starts collapsed */
    if (window.matchMedia('(max-width: 989px)').matches) {
      var d = document.querySelector('.dv-pdp__acc details[open]'); if (d) d.removeAttribute('open');
    }

    if (reduce || !('IntersectionObserver' in window)) { els.concat(wipes).forEach(function (e) { e.style.clipPath = ''; e.classList.add('is-in'); }); return; }
    var wo = new IntersectionObserver(function (en) { en.forEach(function (e) { if (e.isIntersecting) { e.target.style.clipPath = ''; e.target.classList.add('is-in'); wo.unobserve(e.target); } }); }, { threshold: 0 });
    wipes.forEach(function (w) { wo.observe(w); });
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in'); io.unobserve(e.target);
        if (e.target.classList.contains('pk-spec__cell')) {
          nums.forEach(function (n) {
            if (!e.target.contains(n.node) || n.done) return; n.done = true;
            var t0 = performance.now(), d = 900;
            (function step(t) { var p = Math.min(1, (t - t0) / d); var v = Math.round(n.to * (1 - Math.pow(1 - p, 3))); var s = String(v); while (s.length < n.w) s = '0' + s; n.node.textContent = s; if (p < 1) requestAnimationFrame(step); })(t0);
          });
        }
      });
    }, { threshold: .15, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (e) { io.observe(e); });
  });
})();
